import React from "react";
import { useNavigate } from "react-router-dom";
import "../../styles/About.css";

const About = () => {
  const navigate = useNavigate();

  return (
    <div className="about-page">
      <div className="logo" onClick={() => navigate("/")}>
        토익몬
      </div>

      <div className="about-content">
        <div className="about-header">
          <h1>토익몬 소개</h1>
          <p>토익 점수 달성을 위한 최고의 파트너</p>
        </div>

        <div className="about-sections">
          <section className="about-section">
            <h2>우리의 미션</h2>
            <p>
              토익으로 인해 다음 목표를 향한 과정이 붙잡혀 있는 사람들을 돕는
              것이 토익몬의 미션입니다. 단순히 문제를 풀게 하는 것이 아니라,
              토익을 빠르게 정복하기 위한 효율적인 방법에 집중하여 여러분의
              시간과 노력을 절약해 드립니다.
            </p>
          </section>

          <section className="about-section">
            <h2>토익몬이 다른 이유</h2>
            <p>
              토익몬은 단순한 문제 은행이 아닙니다. 우리는 오로지 토익을 빨리
              정복하기 위한 방법에 집중합니다. 모든 문제에는 상세한 단계별
              가이드가 함께 제공되어, 정확히 어떻게 접근해야 하는지 이해할 수
              있도록 도와드립니다.
            </p>
            <p>
              각 문제 유형을 정확하게 해결하는 데 필요한 전략과 기술을 가르치는
              데 중점을 두어, 실력과 자신감을 키워드립니다. 까다로운 문법 규칙을
              이해하든, 복잡한 리스닝 섹션을 해독하든, 토익몬은 실제 시험에
              완벽하게 대비할 수 있도록 지원합니다.
            </p>
          </section>

          <section className="about-section">
            <h2>토익몬이 존재하는 이유</h2>
            <p>
              토익은 단순히 답을 외우는 것이 아니라 방법을 마스터하는 것입니다.
              우리는 기존 시스템에서 부족한 점을 발견했기 때문에 토익몬을
              만들었습니다. 너무 많은 플랫폼이 질보다 양에 중점을 두어,
              학습자들이 명확한 전략 없이 문제에 압도당하고 있었습니다.
            </p>
            <p>
              토익몬은 이를 바꾸기 위해 존재합니다. 우리는 학습자들이 원하는
              점수를 달성하는 데 필요한 도구, 통찰력, 자신감을 제공하기 위해
              최선을 다하고 있습니다. 토익몬과 함께라면, 단순히 토익을 준비하는
              것이 아니라 성공하는 방법을 배우게 됩니다.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default About;
